/* global window, document */
/*
 * CS Scootershop — Kategorie-Navigator: Zustand-Switch (Alle/Neu/Gebraucht)
 *
 * Die Sichtbarkeit (leere Karten/Subs ausblenden, richtigen Count zeigen)
 * regelt reines CSS über [data-scope] am Root. Dieses Script tauscht nur:
 *   - data-scope am Root (Trigger für die CSS-Regeln)
 *   - hrefs der Links (data-href-alle / data-href-neu / data-href-gebraucht)
 *   - aria-pressed der Switch-Buttons
 * Ohne JS bleibt der server-seitig gerenderte Default-Scope voll nutzbar
 * (Progressive Enhancement) — nur der Switch ist dann wirkungslos.
 */

(function () {
  'use strict';

  // Das Snippet bindet dieses Script pro Instanz ein (PLP-Navigator + Drawer-
  // Navigator auf derselben Seite) — nur einmal initialisieren.
  if (window.dcbCatTreeInit) return;
  window.dcbCatTreeInit = true;

  var HREF_KEYS = { alle: 'hrefAlle', neu: 'hrefNeu', gebraucht: 'hrefGebraucht' };
  // Nur die "Alle ansehen"-Zeile (dcb-cattree__view-all-link) trägt zusätzlich
  // data-label-*/data-aria-* — andere a[data-href-alle]-Links (Sub-Items,
  // Cluster-View-all) haben nur Hrefs, deren Text ist scope-unabhängig.
  var LABEL_KEYS = { alle: 'labelAlle', neu: 'labelNeu', gebraucht: 'labelGebraucht' };
  var ARIA_KEYS = { alle: 'ariaAlle', neu: 'ariaNeu', gebraucht: 'ariaGebraucht' };

  function applyScope(root, scope) {
    if (!HREF_KEYS[scope]) return;
    root.setAttribute('data-scope', scope);

    root.querySelectorAll('[data-scope-btn]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.getAttribute('data-scope-btn') === scope));
    });

    var hrefKey = HREF_KEYS[scope];
    var labelKey = LABEL_KEYS[scope];
    var ariaKey = ARIA_KEYS[scope];
    root.querySelectorAll('a[data-href-alle]').forEach(function (a) {
      if (a.dataset[hrefKey]) a.setAttribute('href', a.dataset[hrefKey]);

      // Sichtbarer Text und Accessible Name bleiben synchron zum neuen Href
      // (a11y-Feedback 2026-09-17) — sonst zeigt/liest ein Screenreader nach
      // dem Umschalten weiter "Alle Artikel ansehen", obwohl der Link jetzt
      // auf Neuware/Gebrauchtware zeigt.
      if (a.dataset[labelKey]) {
        var textEl = a.querySelector('[data-viewall-text]');
        if (textEl) textEl.textContent = a.dataset[labelKey];
      }
      if (a.dataset[ariaKey]) a.setAttribute('aria-label', a.dataset[ariaKey]);
    });
  }

  function initTree(root) {
    // Dawns MenuDrawer bindet onCloseButtonClick an ALLE <button> im Drawer
    // (gedacht für die „Zurück"-Buttons) — ein Klick auf unsere Scope-Buttons
    // würde das Menü schließen. Klonen entfernt die fremden Listener; unsere
    // Click-Delegation hängt am Navigator-Root und bleibt wirksam.
    if (root.closest('.menu-drawer')) {
      root.querySelectorAll('[data-scope-btn]').forEach(function (btn) {
        btn.replaceWith(btn.cloneNode(true));
      });
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-scope-btn]');
      if (!btn || !root.contains(btn)) return;
      applyScope(root, btn.getAttribute('data-scope-btn'));
    });
  }

  // Sticky-Offset für den mobilen Zustand-Switch: der Shop-Header ist
  // always-sticky und schrumpft beim Scrollen (reduce-logo-size) — wir messen
  // seine aktuelle Höhe per rAF-throttled scroll/resize und stellen sie als
  // CSS-Variable bereit (Nutzung in dcb-category-tree.css).
  function initStickyOffset() {
    var header = document.querySelector('.section-header');
    if (!header || !document.querySelector('.dcb-cattree--home, .dcb-cattree--collection')) return;
    var pending = false;
    function measure() {
      pending = false;
      var h = Math.ceil(header.getBoundingClientRect().height);
      document.documentElement.style.setProperty('--dcb-cattree-sticky-top', h + 'px');
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(measure);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    measure();
  }

  function boot() {
    document.querySelectorAll('.dcb-cattree').forEach(initTree);
    initStickyOffset();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
